import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=97567b0c&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=97567b0c&prod&scoped=true&lang=css"
import style1 from "./Leaderboard.vue?vue&type=style&index=1&id=97567b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97567b0c",
  null
  
)

export default component.exports